import { cn } from '../../lib/cn';
import type { SuccessMetricRow } from '../../enterprisebeta/framework';

type Props = { metrics?: SuccessMetricRow[] };

export function SuccessTrackingPanel({ metrics = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
      {metrics.map((m) => (
        <div key={m.metric} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{m.metric}</p>
          <p className="mt-1 text-lg font-semibold">{m.value}</p>
          <div className="mt-1 flex items-center justify-between">
            <p className="text-xs text-slate-500">target {m.target}</p>
            <span className={cn(
              'text-xs font-medium',
              m.status === 'exceeded' ? 'text-success-600' : 'text-brand-600',
            )}>
              {m.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
